export default {
    magnificPopup: {
        type: 'image'
    },
    cookieconsent: {
        "//": "You can generate a config for the banner on https://cookieconsent.insites.com/download/",
        palette: {
            popup: {
                background: "#efefef",
                text: "#404040"
            },
            button: {
                background: "#8ec760",
                text: "#ffffff"
            }
        },
        showLink: false,
        theme: "edgeless",
        position: "bottom-right",
        content: {
            message: "Es werden lediglich technische Cookies für den Webseitenbetrieb verwendet. Die Speicherdauer liegt bei 12 Monaten.",
            dismiss: "OK"
        }
    }

}